<div class="container-lg my-5">
  <h3 jhiTranslate="cookies.title"></h3>
  <hr />
  <section>
    <h4 class="my-3" jhiTranslate="cookies.intro.title"></h4>
    <p jhiTranslate="cookies.intro.paragraph"></p>
  </section>
  <section>
    <h4 class="my-3" jhiTranslate="cookies.whatIsACookie.title"></h4>
    <p jhiTranslate="cookies.whatIsACookie.paragraph"></p>
  </section>
  <section>
    <h4 class="my-3" jhiTranslate="cookies.typeOfCookies.title"></h4>
    <div>
      <h5 class="mb-3" jhiTranslate="cookies.typeOfCookies.necessaryCookies.title"></h5>
      <p jhiTranslate="cookies.typeOfCookies.necessaryCookies.paragraph"></p>
    </div>
    <div>
      <h5 class="my-3" jhiTranslate="cookies.typeOfCookies.analyticsCookies.title"></h5>
      <p jhiTranslate="cookies.typeOfCookies.analyticsCookies.paragraph"></p>
    </div>
  </section>
  <section>
    <h4 class="my-3" jhiTranslate="cookies.consentManagement.title"></h4>
    <div>
      <h5 class="mb-3" jhiTranslate="cookies.consentManagement.cookiesChoice.title"></h5>
      <div>
        <p jhiTranslate="cookies.consentManagement.cookiesChoice.paragraph"></p>
        <ul>
          <li jhiTranslate="cookies.consentManagement.cookiesChoice.list.necessaryCookies"></li>
          <li jhiTranslate="cookies.consentManagement.cookiesChoice.list.analyticsCookies"></li>
        </ul>
      </div>
    </div>
    <div>
      <h5 class="my-3" jhiTranslate="cookies.consentManagement.howToManageTheCookies.title"></h5>
      <p jhiTranslate="cookies.consentManagement.howToManageTheCookies.paragraph"></p>
    </div>
  </section>
  <section>
    <h4 class="my-3" jhiTranslate="cookies.useOfTrackingTools.title"></h4>
    <p jhiTranslate="cookies.useOfTrackingTools.paragraph"></p>
    <div>
      <h5 class="my-3" jhiTranslate="cookies.useOfTrackingTools.googleAnalytics.title"></h5>
      <p jhiTranslate="cookies.useOfTrackingTools.googleAnalytics.paragraph"></p>
    </div>
    <div>
      <h5 class="my-3" jhiTranslate="cookies.useOfTrackingTools.sentry.title"></h5>
      <p jhiTranslate="cookies.useOfTrackingTools.sentry.paragraph"></p>
    </div>
  </section>
  <section>
    <h4 class="my-3" jhiTranslate="cookies.consentAndSaving.title"></h4>
    <p jhiTranslate="cookies.consentAndSaving.paragraph"></p>
  </section>
  <section>
    <h4 class="my-3" jhiTranslate="cookies.policyModifications.title"></h4>
    <p jhiTranslate="cookies.policyModifications.paragraph"></p>
  </section>
  <section>
    <h4 class="my-3" jhiTranslate="cookies.contact.title"></h4>
    <p jhiTranslate="cookies.contact.paragraph"></p>
  </section>
</div>
